export default __webpack_public_path__ + "static/article-real-stories-saving-spending-lending-hamish-0ed8aa87b1c04950f8b2d07793b1d62f.jpg";